import React, { useState } from 'react';
import {
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    List,
    ListItem,
    ListItemText,
    Typography,
    Box, Divider
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import {
    currencySymbol,
    getDisplayDate,
    getDisplayTime,
    price,
    showExactDate,
    showSimpleDate, truncate
} from "../../../../../config/values";
import {useTranslation} from "react-i18next";
import {Check, Info, UserRound,ArrowUp} from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";

const StockHistoryButton = ({ classes, ownerships = [] }) => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            {
                ownerships.length > 1 &&
                <>
                    <IconButton onClick={handleOpen} aria-label="View Ownerships">
                        <Info className="lucide-icon-secondary" />
                    </IconButton>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        maxWidth="sm"
                        fullWidth
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogTitle className="dialog-title">
                            {t('stockHistory')}
                            <IconButton aria-label="close" className={classes.dialogClose} onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <Divider />
                        <DialogContent dividers>
                            <List className="ownerships">
                                {ownerships.map((ownership, index) => (
                                    <ListItem key={index}  className={index === 0 ? "activeOwner p-0": " p-0"}>
                                        <ListItemText
                                            className="flex-space bg-gray-box "
                                            primary={
                                                 <div className="d-flex" style={{gap:10}}>
                                                     <Typography className='font-12 '>{index !== 0 ? <ArrowUp/> : <Check/>}</Typography>
                                                     <Typography variant="subtitle1" >
                                                         {truncate(ownership.user.first_name + " " + ownership.user.last_name,18)}
                                                     </Typography>
                                                 </div>
                                            }
                                            secondary={
                                                <div className="d-flex" style={{gap:20}}>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {t('time')}: <span dir="ltr">{getDisplayTime(ownership.created_at)}</span>
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {`${t('price')}: ${price(ownership.price)} ${currencySymbol}`}
                                                    </Typography>
                                                </div>
                                            }
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </DialogContent>
                    </Dialog>
                </>
            }

        </>
    );
};
export default withStyles(Styles)(StockHistoryButton);

